import React, { Component } from 'react';
import PropTypes from 'prop-types';


import Grid from '@mui/material/Grid';

const s:any = {
  grid: {
    minHeight: '100vh',
  },
};

class InfoGrid extends Component<any,any> {
  static propTypes: any;
  static defaultProps: any;
  render() {
    const {children,classes} = this.props;
    return (
      <Grid
        container
        spacing={0}
        direction="column"
        alignItems="center"
        justifyContent="center"
        sx={{...s.grid}}
      >
        <Grid size={{xs:12,sm:6}}>
          {children}
        </Grid>   
      </Grid> 
    );
  }
}

InfoGrid.propTypes = {
  classes: PropTypes.object,
  children: PropTypes.arrayOf(PropTypes.element).isRequired,
};

export default InfoGrid;
